import { GiRolledCloth } from "react-icons/gi";
import { useParams } from "react-router-dom";
import useSetSidebar from "effects/useSidebar";
import Capabilities from "lib/constants/Capabilities";
import { useSelector } from "store";
import { selectRagBinByID, selectStorageByID } from "store/reducers";
import { Restrict } from "components/Restricted";
import { SidebarImageHeader } from "components/shared/sidebars/SidebarImageHeader/SidebarImageHeader";
import { MenuItem } from "components/sidebars/MenuItem/MenuItem";
import Sidebar, { MenuSeparator } from "components/sidebars/Sidebar";

export const RagBinSidebar = () => {
  useSetSidebar(true);
  const { ragControllerID, ragBinID } = useParams();
  const url = `/apps/storage/rag_controllers/${ragControllerID}/bins/${ragBinID}`;
  const entity = useSelector(selectRagBinByID(ragBinID || ""));
  const storage = useSelector(selectStorageByID(entity?.storageId || ""));
  return (
    <Sidebar>
      {entity && <SidebarImageHeader name={storage?.name || ""} imageUrl={entity?.imageUrl} />}
      <MenuSeparator />
      <Restrict capability={Capabilities.RAG_CONTROL_READ}>
        <MenuItem to={`/apps/storage/rag_controllers/${ragControllerID}/dashboard`} icon={<GiRolledCloth />}>
          Rag controller
        </MenuItem>
      </Restrict>
      <Restrict capability={Capabilities.RAG_CONTROL_UPDATE}>
        <MenuItem to={`${url}/settings`} icon="/images/icons/config_2.svg">
          Settings
        </MenuItem>
      </Restrict>
    </Sidebar>
  );
};
